import { render, staticRenderFns } from "./AvatarName.vue?vue&type=template&id=e7051b2c&scoped=true&"
import script from "./AvatarName.vue?vue&type=script&lang=js&"
export * from "./AvatarName.vue?vue&type=script&lang=js&"
import style0 from "./AvatarName.vue?vue&type=style&index=0&id=e7051b2c&prod&lang=css&"
import style1 from "./AvatarName.vue?vue&type=style&index=1&id=e7051b2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7051b2c",
  null
  
)

export default component.exports